import {useMutation} from '@apollo/client';
import {REGISTER_USER} from "../userTypeDefs";

export const useMutationRegisterUser = (options?: any): any => (
  useMutation(REGISTER_USER, options)
);